import { render, staticRenderFns } from "./Step2-Type1-Footer.vue?vue&type=template&id=7c8d0185&"
import script from "./Step2-Type1-Footer.vue?vue&type=script&lang=js&"
export * from "./Step2-Type1-Footer.vue?vue&type=script&lang=js&"
import style0 from "./Step2-Type1-Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports